module.exports = __webpack_public_path__ + "static/media/titlecard_favedeal.8e8ea58c.jpg";